import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Img01 from '../../img/feature2-1.png'
import Img02 from '../../img/feature2-2.png'
import Img03 from '../../img/feature2-3.png'
import { Box, Container, Typography, useMediaQuery } from '@material-ui/core';
import { AiOutlineCheck } from "react-icons/ai"
import { withNamespaces } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    // ----------------------------------------------------
    shader: {
        backgroundColor: '#e0fcea'
    },
    fontFamily: {
        fontFamily: `'Roboto', sans-serif`,
        lineHeight: 1.25
    },
    headPreTitle: {
        textAlign: "center",
        fontSize: 35,
        fontWeight: 300,
        [theme.breakpoints.down("sm")]: {
            fontSize: 20,
        },
    },
    headTitle: {
        textAlign: "center",
        fontSize: 40,
        [theme.breakpoints.down("sm")]: {
            fontSize: 25,
        },
    },
    blockGrid: {
        minHeight: 350,
    },
    contentTitle: {
        fontWeight: "bold",
        fontSize: 25,
        [theme.breakpoints.down("sm")]: {
            fontSize: 20,
        },
    },
    contentGrid: {
        flex: 1,
    },
    content: {
        [theme.breakpoints.down("sm")]: {
            fontSize: 15,
        },
    },
    CalculatorTitle: {
        textAlign: "center",
        fontSize: 30
    },
    CalculatorSubTitle: {
        textAlign: "center",
        fontSize: 25
    },
    contentLineGrid: {
        paddingTop: 20
    },
    pt20: {
        paddingTop: 20
    }
}));

function InstantInsurancePlanning({ t }) {
    const theme = useTheme();
    const classes = useStyles();
    const themeMainColor = theme.palette.primary.main
    let isOverMd = useMediaQuery(theme.breakpoints.up('md'))


    const ContentLine = ({ content }) => {
        return (
            <Grid item>
                <Grid item container xs={12} direction="row" alignItems="center" className={classes.contentLineGrid}>
                    <Grid style={{ paddingRight: 20 }}>
                        <AiOutlineCheck size={30} color={themeMainColor} />
                    </Grid>
                    <Grid item container className={classes.contentGrid}>
                        <Typography className={classes.content}>
                            {content}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    return (
        <Grid className={classes.fontFamily}>
            <Grid>
                <Box p={10} />
                <h1 className={classes.headPreTitle} style={{ textDecoration: "underline", textDecorationColor: themeMainColor }}>
                    {t("smart-saving")}
                </h1>
                <h2 className={classes.headTitle}>
                    {t("why-mylife-platform")}
                </h2>
            </Grid>
            <Box p={3}></Box>
            <Container>
                <Grid container item direction="row" alignItems="flex-end">
                    <Grid item container md={6} xs={12} justify="center" alignItems="center">
                        <img src={Img01} alt="img01" width="100%" style={isOverMd ? { paddingRight: 70 } : {}} />
                    </Grid>
                    <Grid item container md={6} xs={12} direction="column" className={classes.blockGrid}>
                        <Grid item>
                            <Typography className={classes.contentTitle}>
                                {t("goal-saving")}
                            </Typography>
                        </Grid>
                        <Typography className={classes.pt20}>
                            {t("insurance-planning-is")}

                        </Typography>
                        <Typography className={classes.pt20}>
                            {t("in-our-app")}

                        </Typography>

                    </Grid>
                </Grid>
            </Container>
            <Grid className={classes.shader} style={{ paddingTop: 30, paddingBottom: 30 }}>
                <Container>
                    <Grid container item direction="row" alignItems="flex-end">
                        {
                            !isOverMd
                            &&
                            <Grid item md={6} xs={12}>
                                <img src={Img02} alt="img02"
                                    style={{
                                        width: "55%",
                                        marginLeft: "auto",
                                        marginRight: "auto",
                                        display: "block"
                                    }}
                                />
                            </Grid>
                        }
                        <Grid item container md={6} xs={12} direction="column" className={classes.blockGrid}>
                            <Grid item>
                                <Typography className={classes.contentTitle}>
                                    {t("instant-financial")}
                                </Typography>
                            </Grid>
                            <Typography className={classes.pt20}>
                                {t("there-are-several")}

                            </Typography>
                            <Typography className={classes.pt20}>
                                {t("in-our-app-you")}

                            </Typography>
                        </Grid>
                        {
                            isOverMd
                            &&
                            <Grid item md={6} xs={12}>
                                <img src={Img02} alt="img02" 
                                style={{
                                    width: "55%",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    display: "block"
                                }}
                                />
                            </Grid>
                            
                        }
                    </Grid>
                </Container>
            </Grid>
            <Container>
                <Grid container item direction="row" alignItems="flex-end">
                    <Grid item md={6} xs={12} style={{ marginTop: 100 }} >
                        <img src={Img03} alt="img02"
                            style={{
                                width: "70%",
                                marginLeft: "auto",
                                marginRight: "auto",
                                display: "block"
                            }}
                        />
                    </Grid>
                    <Grid item container md={6} xs={12} direction="column" justify="flex-start" className={classes.blockGrid}>
                        <Grid item>
                            <Typography className={classes.contentTitle}>
                                {t("summary-report")}
                            </Typography>
                        </Grid>
                        <ContentLine content={t("different-background")} />
                        <ContentLine content={t("present&future")} />
                        <ContentLine content={t("how-much-you")} />
                        <ContentLine content={t("a-list-of")} />
                    </Grid>
                </Grid>
            </Container>
        </Grid>
    );
}

export default withNamespaces()(InstantInsurancePlanning)